/** @format */

import { useEffect } from "react";
import Navbar from "../shared/components/navbar";
import Footer from "../shared/components/footer";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "fusion-plugin-react-router";
import useAppStateStore from "../shared/store/AppStateStore";
import QuoteStep from "../features/quote/enums/QuoteStep";
import { TrackHotjarEvent } from "../shared/utils/trackHotjarEvent";
import { HotjarEventNames } from "../shared/utils/hotjarEventNames";
import { goBackToLastStep } from "../shared/utils/navigationUtils";

const ErrorPage = () => {
  const css = assetUrl("../styles/notFound.css");
  const mainCss = assetUrl("../styles/main.css");
  const [searchParams] = useSearchParams();
  const errorUrl = searchParams.get("url");
  const navigate = useNavigate();
  const rawMessage = searchParams.get("message");
  const parsedMessage = decodeURIComponent(rawMessage);
  const ServerErrorImage = assetUrl("../assets/images/error_500.jpg");
  const STATE = useAppStateStore();

  const handleRetry = () => {
    if (
      parsedMessage ===
      "You're not logged in, please click retry to login and then proceed."
    ) {
      navigate("/");
    } else if (parsedMessage === "Timed Out") {
      navigate("/taxi/quote");
      STATE.setMemberRetry && STATE.setMemberRetry(true);
    } else {
      // clearAllStores();
      navigate("/taxi/quote");
      if (STATE.currentStep === QuoteStep.TQ_PANEL_LOADER) {
        goBackToLastStep();
      }
    }
  };

  useEffect(() => {
    TrackHotjarEvent(HotjarEventNames.TAXI_ERROR_SERVER);
  }, []);

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <link rel="stylesheet" href={css} />
        <link rel="stylesheet" href={mainCss} />
      </Helmet>
      <Navbar />
      <div className="mainBody">
        <div className="flex">
          <div className=" form container">
            <img
              src={ServerErrorImage}
              className="margin-top-30 image"
              style={{
                height: "auto",
                width: "100%",
                alignSelf: "center",
                objectFit: "cover",
              }}
            />
            <h1 className="margin-top-30">Error! Something went wrong.</h1>
            <p className="margin-top-15 margin-bottom-0">
              We apologize for the inconvinience, you can contact support by
              clicking the icon at the bottom right of your screen, or try again
              by clicking the below button.
            </p>
            {parsedMessage ? (
              typeof parsedMessage === "object" ? (
                <pre>{JSON.stringify(parsedMessage, null, 2)}</pre>
              ) : (
                <p>{parsedMessage}</p>
              )
            ) : (
              errorUrl && <p>Failed to fetch from: {errorUrl}</p>
            )}
            <button
              type="button"
              className="getStartedButton margin-top-30 margin-bottom-30"
              onClick={handleRetry}
            >
              Retry
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ErrorPage;
